import { Component, OnInit } from '@angular/core';
import { ProjectServicesService } from '../shared/services/project-services.service';
import { SharedService } from '../shared/services/shared.service';
import { Config } from '../config';
import { AppService } from '../shared/services/app.service';
import {
  faInfo,
  faFileExport,
  faChevronLeft,
  faChevronRight,
  faPlus,
  faListOl,
  faLock,
  faTrash,
  faLightbulb,
  faTimes,
  faEdit,
  faCircle,
  faInfoCircle,
} from '@fortawesome/free-solid-svg-icons';
import { Quill } from 'quill';
import { EditorChangeContent, EditorChangeSelection } from 'ngx-quill';
declare module 'quill';
declare var $: any;

import diff from 'fast-diff';
import QuillType from 'quill';
declare module 'quill';
import Delta from 'quill';
import { Subscription } from 'rxjs';
import { SocketService } from '../shared/services/socket.service';
import { ReloadToolService } from '../shared/services/reload-tool.service';
import { MainComponent } from '../main/main.component';

@Component({
  selector: 'app-checklist',
  templateUrl: './checklist.component.html',
  styleUrls: ['./checklist.component.scss'],
})
export class ChecklistComponent implements OnInit {
  faCircle = faCircle;
  faListOl = faListOl;
  faEdit = faEdit;
  faInfoCircle = faInfoCircle;
  faLock = faLock;
  faTrash = faTrash;
  faLightbulb = faLightbulb;
  faTimes = faTimes;
  faFileExport = faFileExport;
  faChevronLeft = faChevronLeft;
  faChevronRight = faChevronRight;
  faPlus = faPlus;
  modelData: any;
  checklistEditorContent: any = '';
  toastMsgPopup: any = '';
  editorContent: any = '';
  config: any;
  model: any;
  errorMessage: any;
  oldChecklistName: any = '';
  selectedChecklist: any = {
    checklistName: '',
    checklistId: '',
    checkType: '',
    _id: '',
  };
  checklistObj: any = {};
  showText: any = false;
  new: any = true;
  updateChecklistName: any = false;
  checklistName: any = '';
  Count: any = 0;
  publicChecklists: any = [];
  clickEventsubscription: Subscription;
  clickEventsubscriptionSocket: Subscription;
  smartChecklist: boolean = true;
  syncModelDataObject: any;

  constructor(
    private ProjectServices: ProjectServicesService,
    private _sharedService: SharedService,
    private socketService: SocketService,
    private reloadToolService: ReloadToolService,
    private Config: Config,
    public mainComponent: MainComponent,
    private AppService: AppService
  ) {
    this.clickEventsubscriptionSocket = this.socketService
      .getClickEvent()
      .subscribe(() => {
        this.ngOnInit();
      });

    this.clickEventsubscription = this._sharedService
      .getClickEvent()
      .subscribe((checklist) => {
        if (checklist.toolType == 'cl') {
          this.chooseChecklist(false, false, checklist);
        }
      });
  }

  ngOnInit(): void {
    setTimeout(() => {
      this.getVideoURL('Cl');
    }, 2000);
    this.getPublicChecklists();
    this.config = this.Config;
    this.modelData = this._sharedService.loadedProjectData.model;
    setInterval(() => {
      this.updateProjectData();
    }, 2000);
  }


  openChatGPTassist() {
    this.mainComponent.openChatGPT();
    window.localStorage.setItem("assistantTool", "RECON");
    setTimeout(() => {
      // if (this.choosenEUT) {
      //   this.loadEntityDetails(this.choosenEUT);
      // }
    }, 500);
  }
  // this.model = model;
  // this.AppService = AppService;
  // this.tasks = tasks;
  // this.planner = planner;
  // this.taskPlanner1 = taskPlanner1;

  // window.localStorage.removeItem('checklistDetails');

  // onReloadInit(){
  //   this.chooseChecklist(this.new, this.showText, this.checklistObj);
  // }
  checklistNoteLoad() {
    if (this.Count == 0) {
      // var iframe = document.getElementById('checklistNotepad');
      // iframe.src = iframe.src;
      this.Count++;
    }
  }
  updateProjectData() {
    this._sharedService.projectContent(this.modelData);
  }
  checklistNoteReload() {
    // var iframe = document.getElementById('checklistNotepad');
    // iframe.src = iframe.src;
  }

  //function is called when clicked on any checklist from the drop down
  chooseChecklist(newButton: any, textBox: any, checklist: any) {
    this.new = newButton;
    this.showText = textBox;
    this.selectedChecklist = checklist;
    this.checklistName = checklist.checklistName;
    this.checklistObj = checklist;
    window.localStorage.setItem('checklistDetails', JSON.stringify(this.selectedChecklist));
    this.getChecklistData();
  }

  editorChanged(event: EditorChangeContent | EditorChangeSelection) {
    this.editorContent = event['editor']['root']['innerHTML'];
    // if(event['event'] == 'selection-change'){
    //   var range: any = event['range'];
    //   var selectedString = event['editor']['root']['innerText'].substring(range['index'], range['length']++);

    // }else{
    // let project = {"projectID": window.localStorage.getItem('projectID'),

    // "userID": window.localStorage.getItem('userID'),"content": this.editorContent};
    var checklistData = {
      projectID: window.localStorage.getItem('projectID'),
      checklistId: this.selectedChecklist.checklistId,
      checklistName: this.selectedChecklist.checklistName,
      content: this.editorContent,
      userID: window.localStorage.getItem('userID'),
    };
    this.ProjectServices.addChecklistContent(checklistData).subscribe(
      (response: any) => {
        if (response.statusCode == 200) {
          // this.quillEditorContent = response.record.content;
        } else {
        }
      }
    );
    // }
  }
  getChecklistData() {
    var token = window.localStorage.getItem('publicToken');
    var projectID = window.localStorage.getItem('projectID');
    // var checklistDetails: any = JSON.parse(window.localStorage.getItem("checklistDetails") || {});
    if (this.selectedChecklist) {
      if (this.selectedChecklist.checkType == 'private') {
        if (this.selectedChecklist.checklistId != undefined) {
          var jsonObjects = {
            projectID: projectID,
            checklistId: this.selectedChecklist.checklistId,
          };
          this.ProjectServices.getChecklistContent(
            jsonObjects,
            token
          ).subscribe((response: any) => {
            if (response.statusCode == 200) {
              this.checklistEditorContent = response.record.content;
            } else {
            }
          });
        }
      } else if (this.selectedChecklist.checkType == 'public') {
        var jsonObjectsData = { id: this.selectedChecklist._id };
        this.ProjectServices.getPublicChecklistContent(
          jsonObjectsData,
          token
        ).subscribe((response: any) => {
          if (response.statusCode == 200) {
            this.checklistEditorContent = response.record.content;
          } else {
          }
        });
      }
    }
  }

  getPublicChecklists() {
    this.ProjectServices.getPublicChecklists().subscribe((response: any) => {
      if (response.statusCode == 200) {
        this.publicChecklists = response.records;
      } else {
      }
    });
  }

  triggerToastPopup(message: any) {
    this.toastMsgPopup = message;
    // $('#checklistMsgPopup').modal('toggle');
  }

  addChecklist(newname: any) {
    this.checklistEditorContent = '';
    if (this.checklistName == undefined) {
      this.errorMessage = "Checklist can't be empty";
      $("#checklistDuplicateModel").modal("show");
      return;
    }
    var checklistExist = this.modelData.checklists.find(
      (checklist: any) => checklist.checklistName == this.checklistName
    );
    if (checklistExist) {
      this.errorMessage = 'Checklist already exists!!';
      $("#checklistDuplicateModel").modal("show");
      // this.triggerToastPopup(this.AppService.getResourceText('V022'));
      return;
    } else {
      var newChecklist = {
        checklistName: this.checklistName,
        checklistId: this.uuidv4(),
        checkType: 'private',
      };
      this.modelData.checklists.push(newChecklist);
      this.syncModelDataObject = {
        "type": "CHECKLIST",
        "operation": "CREATE",
        "data": newChecklist
      }
      this.mainComponent.updateActiveUsersModel(this.syncModelDataObject);
      this.new = false;
      this.showText = false;
      // var checklist = this.modelData.checklists.find(
      //   (checklist: any) => checklist.checklistName == this.checklistName
      // );
      this.selectedChecklist = newChecklist;
      this.checklistName = newChecklist.checklistName;
      window.localStorage.setItem(
        'checklistDetails',
        JSON.stringify(this.selectedChecklist)
      );
    }
    // this.checklistNoteReload();
  }

  editChecklist(oldName: any) {
    this.showText = true;
    this.updateChecklistName = true;
    this.oldChecklistName = oldName;
  }

  saveChecklist() {
    if (this.new) {
      this.addChecklist(this.checklistName);
    } else {
      for (let i = 0; i < this.modelData.checklists.length; i++) {
        if (this.modelData.checklists[i].checklistName == this.checklistName) {
          // this.triggerToastPopup(this.AppService.getResourceText("V022"));
          return;
        }
      }
      var checklistUpdate = this.modelData.checklists.find(
        (checklist: any) =>
          checklist.checklistId == this.selectedChecklist.checklistId
      );
      checklistUpdate.checklistName = this.checklistName;
      this.syncModelDataObject = {
        "type": "CHECKLIST",
        "operation": "UPDATE",
        "data": checklistUpdate,
        "name": this.checklistName
      }
      this.mainComponent.updateActiveUsersModel(this.syncModelDataObject);
      this.updateTasksBasedOnChecklistId(checklistUpdate);
      this.new = false;
      this.showText = false;
    }
  }
  getVideoURL(urlName: any) {
    var videoURL = this.AppService.getVideoURL(urlName);
    var element: any = document.getElementById(urlName + 'VideoLink') || {};
    element.src = videoURL;
  }
  //Update tasks with rescept to when checklist updated
  updateTasksBasedOnChecklistId(checklist: any) {
    for (var i = 0; i < this.modelData.tasks.length; i++) {
      if (this.modelData.tasks[i].activity) {
        if (this.modelData.tasks[i].activity.type == 'CL') {
          if (
            this.modelData.tasks[i].checklistDetails.checklistId ==
            checklist.checklistId
          ) {
            var updatedDesc = this.modelData.tasks[i].task_desc.replace(
              /'.*?'/,
              "'" + checklist.checklistName + "'"
            );
            this.modelData.tasks[i]['task_desc'] = updatedDesc;
            this.modelData.tasks[i].checklistDetails['checklistName'] =
              checklist.checklistName;
          }
        }
      }
    }
    // this.planner.controller.loadMytasksList(this.tasks);
    // this.taskPlanner1.controller.loadPlanNamesList(this.tasks);
    // this.taskPlanner1.controller.selectedPlan(false, false, '');
  }

  deleteChecklist(checklist: any) {
    
    // console.log("this.selectedChecklist",this.selectedChecklist);
    var index = this.modelData.checklists.findIndex(
      (checklist: any) =>
        checklist.checklistId == this.selectedChecklist.checklistId
    );
    if (index) {
      this.modelData.checklists.splice(index, 1);
    }
    if (index == 0) {
      this.modelData.checklists.shift();
    }
    // for loop to delete all tasks are matched with deleted checklistID
    for (var i = 0; i < this.modelData.tasks.length; i++) {
      if (this.modelData.tasks[i].checklistDetails) {
        if (
          this.modelData.tasks[i].checklistDetails.checklistId ==
          this.selectedChecklist.checklistId
        ) {
          this.modelData.tasks.splice(i, 1);
          i--;
        }
      }
    }
    this.syncModelDataObject = {
      "type": "CHECKLIST",
      "operation": "DELETE",
      "data": this.selectedChecklist,
    }
    this.mainComponent.updateActiveUsersModel(this.syncModelDataObject);
    // reloadinhg planner and taskplanner on sucessful delete of checklist
    // this.planner.controller.loadMytasksList(this.tasks);
    // this.taskPlanner1.controller.loadPlanNamesList(this.tasks);
    // this.taskPlanner1.controller.selectedPlan(false, false, '');
    setTimeout(() => {
      this.selectedChecklist = {
        checklistName: '',
        checklistId: '',
        checkType: '',
        _id: '',
      }; 
    }, 1000);
    this.checklistEditorContent = '';
    this.new = true;
    this.showText = false;
  }

  clear() {
    this.showText = false;
    if (this.updateChecklistName == true) {
      this.selectedChecklist.checklistName = this.oldChecklistName;
      this.chooseChecklist(false, false, this.selectedChecklist);
      this.updateChecklistName = false;
    } else if (this.updateChecklistName == false) {
      this.selectedChecklist = {
        checklistName: '',
        checklistId: '',
        checkType: '',
        _id: '',
      };
    }
  }
  openSmartChecklist() {
    this.reloadToolService.triggerSmartChecklist('Cl');
    if (this.smartChecklist == false) {
      $(".autoCursor").addClass('checklistIcon');
      this.smartChecklist = true;
    } else {
      $(".autoCursor").removeClass('checklistIcon');
      this.smartChecklist = false;
    }
  }
  generateReport(auto: any) {
    let mapperArray = ['Checklist'];
    window.localStorage.setItem('exportedData', JSON.stringify(mapperArray));
    if (auto == 'true') {
      window.open('/exportReport', '_blank');
      window.localStorage.setItem('autoDownload', 'true');
    }
  }
  terminateVideo() {
    var iframes = document.querySelectorAll('iframe');
    Array.prototype.forEach.call(iframes, (iframe) => {
      iframe.contentWindow.postMessage(
        JSON.stringify({
          event: 'command',
          func: 'stopVideo',
        }),
        '*'
      );
    });
  }
  uuidv4() {
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (c) => {
      var r = (Math.random() * 16) | 0,
        v = c == 'x' ? r : (r & 0x3) | 0x8;
      return v.toString(16);
    });
  }

  goToView() {
    window.open('/exportReport', '_blank');
    // window.open(appConst.redirectHostAddress + "export", "_blank");
  }
}
